<template>
    <div class="permisson">
        <img src="./no-data.png">

        <div class="tips">{{tips}}</div>
        <a :href="url">
            （点我申请）
        </a>

    </div>
</template>
<script>
export default {
    props: {
        tips: {
            type: String,
            default: '您还没有页面访问权限哦～申请权限通过后方能查'
        },
        url: {
            type: String,
            default: 'https://perm.midea.com/flows/permission/100064?tab=1000000854'
        }
    },
    data() {
        return {};
    }
};
</script>
<style scoped lang="less">
.permisson {
    width: 100%;
    height: 100%;
    background-color: #f7f7f7;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
        width: 120px;
        height: 120px;
        float: left;
    }
    .tips {
        display: flex;
        font-size: 12px;
        color: #8c8c8c;
        line-height: 20px;
    }
    a {
        color: rgb(0, 119, 255);
    }
    .container {
        display: flex;
        flex-direction: column;
    }
}
</style>